// extracted by mini-css-extract-plugin
export default {"select":"styles_select__2XPq7","storeIcon":"styles_storeIcon__lGZFH","link":"styles_link__WRkeZ"};